import React from 'react';
import Proptypes from 'prop-types';
import { getNSDURLbyModelListId, getChi2RgURLbyModelListId } from '../../../api/ispyb';
import { Grid, Row, Col } from 'react-bootstrap';
import FirContentPlotter from '../../../components/saxs/FirContentPlotter';
import FitContentPlotter from '../../../components/saxs/FitContentPlotter';
import ImageZoom from 'react-medium-image-zoom'


class SaxsAbInitioUpperPanel extends React.Component {
    render() {
        let { subtraction } = this.props;

        let NSDUrl = '';
        let chi2RgUrl = '';
        if (subtraction && subtraction.subtractionId && subtraction.abInitioModels instanceof Array && subtraction.abInitioModels.length > 0 && subtraction.abInitioModels[0].modelList && subtraction.abInitioModels[0].modelList.modelListId) {
            NSDUrl = getNSDURLbyModelListId(this.props.token, subtraction.subtractionId, subtraction.abInitioModels[0].modelList.modelListId);
            chi2RgUrl = getChi2RgURLbyModelListId(this.props.token, subtraction.subtractionId, subtraction.abInitioModels[0].modelList.modelListId);
        }

        return (
            <Grid fluid>
                <Row>
                    <Col xs={12} md={12} lg={3}>
                        <ImageZoom
                            image={{
                                src: NSDUrl,
                                alt: 'NDS image',
                                className: 'img',
                                style: { display: 'block', maxWidth: '100%', height: 'auto', margin: 'auto' }
                            }}
                            zoomImage={{
                                src: NSDUrl,
                                alt: 'Scattering plot'
                            }} />
                    </Col>
                    <Col xs={12} md={12} lg={3}>
                        <ImageZoom
                            image={{
                                src: chi2RgUrl,
                                alt: 'chi2Rg image',
                                className: 'img',
                                style: { display: 'block', maxWidth: '100%', height: 'auto', margin: 'auto' }
                            }}
                            zoomImage={{
                                src: chi2RgUrl,
                                alt: 'Scattering plot'
                            }} />
                    </Col>
                    <Col xs={12} md={12} lg={3}>
                        <FirContentPlotter data={this.props.firContent} />

                        <div style={{ textAlign: 'center', fontStyle: 'italic', color: 'gray' }}>
                            <span>Fit of the simulated scattering curve versus a smoothed experimental data (spline interpolation)</span>
                        </div>
                    </Col >
                    <Col xs={12} md={12} lg={3}>
                        <FitContentPlotter data={this.props.fitContent} />

                        <div style={{ textAlign: 'center', fontStyle: 'italic', color: 'gray' }}>
                            <span>Fit of the simulated scattering curve versus the experimental data.</span>
                        </div>

                    </Col>
                </Row >


            </Grid >)
    }
}

export default SaxsAbInitioUpperPanel;

SaxsAbInitioUpperPanel.proptypes = {
    /* Fir data used to plot 'Fit of the simulated scattering curve versus a smoothed experimental data (spline interpolation)' */
    firContent: Proptypes.array,
    /* */
    token: Proptypes.string

}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsAbInitioUpperPanel.js